import { render, staticRenderFns } from "./Rect.vue?vue&type=template&id=05a81120&"
import script from "./Rect.vue?vue&type=script&lang=ts&"
export * from "./Rect.vue?vue&type=script&lang=ts&"
import style0 from "./Rect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports